export default {
  rollover: {
    title: 'Rollover',
    detailsTitle: 'Detail Rollover',
    all: 'Semua',
    allStats: 'Semua Status',
    select: 'Pilih',
    rolloverType: 'Jenis Rollover',
    amount: 'Jumlah',
    source: 'Sumber',
    wallet: 'Dompet',
    current: 'Saat Ini',
    wagered: 'Dipertaruhkan',
    required: 'Dibutuhkan',
    progress: 'Progres',
    loading: 'Memuat...',
    noData: 'Tidak ada data',
    noMoreData: 'Tidak ada data lagi',
    state: 'Status',
    type: 'Jenis',
    createdOn: 'Dibuat pada',
    wageringRequirement: 'Syarat Taruhan',
    currency: 'Mata Uang',
    wagerRequired: 'Taruhan Dibutuhkan',
    wagerCompleted: 'Taruhan Selesai',
    cash: 'Tunai',
    bonus: 'Bonus',
  },
};
